<template>
    <div>
        <div class="dashboard_faculty_item">
            <div class="dashboard_faculty_item_left">
                <div class="as_link_grey dashboard_faculty_item_name"
                    @click="changeFacultySection({ data: { section_id: section_data.id } })">
                    {{ section_data.name }}
                </div>
                <br><br>
                <div class="deadline_status" :class="deadlineStatus">{{ status_text }}</div>
                <div class="dashboard_faculty_item_progress">
                    Oddano: {{ list_data.faculty_submitted_count }} / {{ list_data.faculty_count }}
                </div>
            </div>

            <div class="dashboard_faculty_item_right">
                <div class="dashboard_faculty_item_deadline">
                    <div v-show="deadlineTimestamp > 0">
                        Rok: {{ getDeadline() }}
                    </div><br>
                    <div v-show="deadlineClosedTimestamp > 0">
                        Zadnji rok: {{ getDeadlineClosed() }}
                    </div>
                </div>
                <div class="dashboard_toggle_section_list" @click="showFaculties = !showFaculties"
                    :class="{ 'active': showFaculties }" v-if="list_data.faculty">
                    prikaži/skrij fakultete
                    <font-awesome-icon v-show="!showFaculties" :icon="['fas', 'angle-down']" />
                    <font-awesome-icon v-show="showFaculties" :icon="['fas', 'angle-up']" />
                </div>
            </div>
        </div>
        <transition name="expand" @after-enter="afterEnter" @enter="enter" @leave="leave">
            <div v-show="showFaculties" class="dashboard_section_list">
                <div class="dashboard_section_item" v-for="faculty in filteredRowByFaculty" :key="faculty.faculty_id">
                    <div class="dashboard_section_item_left">

                        <div class="as_link_grey dashboard_section_name"
                            @click="changeFacultySection({ data: { faculty_id: faculty.faculty_id, section_id: list_data.section_id } })">
                            {{ faculty_data[faculty.faculty_id].acronym }} - {{ faculty_data[faculty.faculty_id].name }}
                        </div>
                        <br>

                        <div v-if="faculty.submitted == 1" class="deadline_status filled">oddano</div>
                        <div v-else class="deadline_status" :class="deadlineStatusFaculty().class">
                            {{ deadlineStatusFaculty().text }}</div>
                    </div>
                    <div class="dashboard_section_item_right">
                        <div class="dashboard_section_item_deadline">
                            <div v-if="faculty.submitted == 1">Oddano: {{ convertDateTime(faculty.submit_time) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>


<script>
import moment from 'moment';
import { mapActions } from 'vuex';

export default {
    name: 'SectionsDashboardSectionListItem',
    data() {
        return {
            deadlineTimestamp: 0,
            deadlineClosedTimestamp: 0,
            status_text: '',
            showFaculties: false,
            nearDeadlineDays: 14
        };
    },
    props: {
        faculty_data: Object,
        section_data: Object,
        list_data: Object
    },
    computed: {
        deadlineStatus() {
            const now = Date.now();

            if (this.list_data.faculty_submitted_count === this.list_data.faculty_count && this.list_data.faculty_count > 0) return 'filled';
            if (this.deadlineClosedTimestamp > 0 && now > this.deadlineClosedTimestamp) return 'after_late';
            if (this.deadlineTimestamp > 0) {
                if (now > this.deadlineTimestamp) return 'after';
                if (now > this.deadlineTimestamp - this.nearDeadlineDays * 86400000) return 'preparation_late';
            }
            return 'preparation';
        },
        filteredRowByFaculty() {
            return Object.values(this.list_data.faculty || {}).sort((a, b) =>
                this.faculty_data[a.faculty_id].acronym > this.faculty_data[b.faculty_id].acronym ? 1 : -1
            );
        }
    },
    watch: {
        deadlineStatus: {
            immediate: true,
            handler(newVal) {
                if (!this.section_data?.id) return;

                this.status_text = {
                    filled: 'oddano',
                    after_late: 'zamujeno',
                    after: 'zamuda',
                    preparation_late: 'v pripravi',
                    preparation: 'v pripravi'
                }[newVal];

                this.dashboardAddLastStatusBySection({
                    id: this.section_data.id,
                    status: 'status_' + newVal
                });
            }
        }
    },
    mounted() {
        this.deadlineTimestamp = this.getTimestamp(this.section_data.deadline);
        this.deadlineClosedTimestamp = this.getTimestamp(this.section_data.deadlineClosed);
    },
    methods: {
        ...mapActions(['dashboardAddLastStatusBySection', 'changeFaculty', 'changeFacultySection']),
        getTimestamp(dateStr) {
            if (!dateStr || dateStr === '0000-00-00') return 0;
            return new Date(dateStr).getTime();
        },
        convertDateTime(datetime) {
            return datetime === '0000-00-00 00:00:00'
                ? 'ni določen'
                : moment(datetime, 'YYYY-MM-DD HH:mm:ss').format('D. M. YYYY');
        },
        getDeadline() {
            if (!this.section_data?.deadline || this.section_data.deadline === '0000-00-00') return '';
            const date = new Date(this.section_data.deadline);
            this.deadlineTimestamp = date.getTime();
            return date.toLocaleDateString("sl-SL");
        },

        getDeadlineClosed() {
            if (!this.section_data?.deadlineClosed || this.section_data.deadlineClosed === '0000-00-00') return '';
            const date = new Date(this.section_data.deadlineClosed);
            this.deadlineClosedTimestamp = date.getTime();
            return date.toLocaleDateString("sl-SL");
        },
        deadlineStatusFaculty(deadline, deadlineClosed) {
            const now = Date.now();
            const ts = deadline !== '0000-00-00' ? new Date(deadline).getTime() : 0;
            const tsClosed = deadlineClosed !== '0000-00-00' ? new Date(deadlineClosed).getTime() : 0;

            if (tsClosed > 0 && now > tsClosed) return { class: 'after_late', text: 'zamujeno' };
            if (ts > 0) {
                if (now > ts) return { class: 'after', text: 'zamuda' };
                if (now > ts - this.nearDeadlineDays * 86400000)
                    return { class: 'preparation_late', text: 'v pripravi' };
            }
            return { class: 'preparation', text: 'v pripravi' };
        },
        afterEnter(el) {
            el.style.height = 'auto';
        },
        enter(el) {
            const { height } = getComputedStyle(el);
            el.style.height = '0';
            getComputedStyle(el).height;
            requestAnimationFrame(() => {
                el.style.height = height;
            });
        },
        leave(el) {
            const { height } = getComputedStyle(el);
            el.style.height = height;
            getComputedStyle(el).height;
            requestAnimationFrame(() => {
                el.style.height = '0';
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.expand-enter-active,
.expand-leave-active {
    transition: height 1s ease-in-out;
    overflow: hidden;
}

.expand-enter,
.expand-leave-to {
    height: 0;
}
</style>
